import { useEffect, useState } from "react";

interface FetchResult<T> {
  data: T | null;
  loading: boolean;
  error: Error | null;
}

export const CommonFetchService = <T,>(url: string): FetchResult<T> => {
    const [data, setData] = useState<T | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);
    
    const uri = new URL(window.location.href);
    const dm = `${uri.protocol}//${uri.hostname}`;
    // console.log(url);
    
    useEffect(() => {
        const fetchData = async () => {
        try {
            const response = await fetch(`${dm}/${url}`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const json = await response.json();
            // console.log(json);
            setData(json as T);
        } catch (e) {
            setError(e as Error);
        } finally {
            setLoading(false);
        }
    };
        fetchData();
    }, [url]);
    return { data, loading, error };
};